import wretch from "wretch";
import { g as getResolverForContentType } from "./get-resolver-for-content-type-DlHTDn7n.js";
function createUnauthorizedCatcher({
  refreshAuth,
  beforeResolve,
  resolve,
  onRetryUnauthorized
}) {
  return async (_, request) => {
    let refreshAuthResult;
    try {
      refreshAuthResult = await refreshAuth({ request });
    } catch (error) {
      if (!onRetryUnauthorized) {
        throw error;
      }
      return onRetryUnauthorized({
        request,
        error,
        refreshAuthResult: null
      });
    }
    const finalRequest = await (beforeResolve == null ? void 0 : beforeResolve({ request, refreshAuthResult })) ?? request;
    if (resolve) {
      return finalRequest.resolve((resolver) => {
        return resolve({ request, refreshAuthResult, resolver });
      }).fetch();
    }
    return finalRequest.resolve(async (resolver) => {
      const response = await resolver._fetchReq;
      const contentType = response.headers.get("content-type");
      const method = getResolverForContentType(contentType);
      const resolveFn = resolver[method];
      resolver.unauthorized(async (error, failedRequest) => {
        if (!onRetryUnauthorized) {
          throw error;
        }
        await onRetryUnauthorized({
          error,
          request: failedRequest,
          refreshAuthResult
        });
      });
      if ("valid" in request._options) {
        const {
          valid: { schema, preprocess }
        } = request._options;
        return resolveFn((data) => schema.parse(preprocess(data)));
      }
      return resolveFn();
    }).fetch();
  };
}
function isHTTPClientError(error) {
  return typeof error === "object" && error !== null && Object.hasOwn(error, "status") && Object.hasOwn(error, "url") && error.response instanceof Response;
}
function createHTTPClient({
  baseURL,
  options
} = {}) {
  return wretch(baseURL, options);
}
export {
  createHTTPClient,
  createUnauthorizedCatcher,
  getResolverForContentType,
  isHTTPClientError
};
//# sourceMappingURL=index.js.map
